import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';
import { useState } from 'react';

const SocialProof = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      quote: 'Go Global Inc. transformed our supply chain process. Their ability to source directly from manufacturers and handle all logistics saved us over 30% on material costs while maintaining exceptional quality standards.',
      author: 'Michael Chen',
      title: 'VP of Operations',
      company: 'Horizon Development Group',
      image: 'https://public.readdy.ai/ai/img_res/f41b1dc74540fb8b4839c16778d83e84.jpg',
    },
    {
      quote: 'The customs expertise and documentation support made international sourcing seamless. We completed a $50M mixed-use project ahead of schedule thanks to their reliable delivery coordination.',
      author: 'Sarah Martinez',
      title: 'Project Director',
      company: 'Continental Builders',
      image: 'https://readdy.ai/api/search-image?query=contemporary%20commercial%20construction%20site%20with%20modern%20building%20facade%20installation%20and%20professional%20contractors%20working%20on%20large%20scale%20project%20in%20organized%20clean%20environment&width=800&height=600&seq=testimonial-bg-002&orientation=landscape',
    },
  ];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            <div className="relative rounded-2xl overflow-hidden border-8 border-gray-100">
              <img
                src={testimonials[activeIndex].image}
                alt="Client Success"
                className="w-full h-96 lg:h-full object-cover object-center"
              />
            </div>
          </motion.div>

          {/* Right - Testimonial Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="lg:col-span-3 lg:pl-12"
          >
            <div className="text-sm text-gray-500 mb-6">(Client Success Story)</div>
            
            <h2 className="font-display font-medium text-3xl md:text-4xl text-gray-900 mb-8">
              Delivering Results for{' '}
              <span className="text-gray-500">Industry Leaders</span>
            </h2>

            <div className="mb-8">
              <div className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-6">
                "{testimonials[activeIndex].quote}"
              </div>
              <div>
                <div className="font-semibold text-gray-900 text-lg">
                  — {testimonials[activeIndex].author}
                </div>
                <div className="text-sm text-gray-600">
                  {testimonials[activeIndex].title}, {testimonials[activeIndex].company}
                </div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex items-center space-x-4">
              <button
                onClick={handlePrev}
                className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-full hover:border-gray-900 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-gray-600"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full hover:bg-gray-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;